const getScreeningStatus = function (statusId) {
  let status = ''
  if (statusId) {
    switch (statusId) {
      case 1:
        status = 'Avvakta blodprovssvar'
        break
      case 2:
        status = 'Bedöma blodprovssvar'
        break
      case 3:
        status = 'Avvakta genetiskt test'
        break
      case 4:
        status = 'Bedöma gentestsvar'
        break
      case 5:
        status = 'Bjuda in som indexpatient'
        break
      case 6:
        status = 'Skapa labbremiss papper'
        break
      case 7:
        status = 'Remittera till vårdcentral'
        break
      case 9:
        status = 'Bekräftad Familjär hyperkolesterolemi (ej tagit gentest)'
        break
      case 10:
        status = 'Bekräftad Familjär hyperkolesterolemi (tagit gentest)'
        break
      case 11:
        status = 'Inte Familjär hyperkolesterolemi (ej tagit gentest)'
        break
      case 12:
        status = 'Inte Familjär hyperkolesterolemi (tagit gentest)'
        break
      case 13:
        status = 'Inbjuden som indexpatient'
        break
      case 14:
        status = 'Skapa remiss genetiskt test'
        break
      case 15:
        status = 'Ta beslut'
        break
      case 16:
        status = 'Kontakta släkting för sjukhus information'
        break
      case 17:
        status = 'Beställa journalkopior'
        break
      case 18:
        status = 'Invänta journalkopior'
        break
      case 19:
        status = 'Kontakta för mer info angående barn under 13 år'
        break
      case 20:
        status = 'Skicka remiss till lipidmottagningen'
        break
      case 21:
        status = 'Läkarbedömning DLCN'
        break
      case 22:
        status = 'Kontakta patient ang gentest'
        break
      case 23:
        status = 'Skicka remissvar till kardiologen'
        break
      case 24:
        status = 'Inväntar videobesök'
        break
      case 25:
        status = 'Ej FH / avbruten screening'
        break
      case 26:
        status = 'Vill inte ingå som indexpatient'
        break
      case 27:
        status = 'Vill avsluta sin delaktighet i FH-screening'
        break
      case 28:
        status = 'Remiss till barnläkare'
        break
      case 29:
        status = 'Inbjuden som indexpatient gen-positiv'
        break
      case 30:
        status = 'Inbjuden som indexpatient gen-negativ'
        break
      case 31:
        status = 'Remiss skickad'
        break
      case 98:
        status = 'Alla oavsett status'
        break
      case 99:
        status = 'Okänd status'
        break
      default:
        break
    }
  }
  return status
}

export {
  getScreeningStatus
}



// WEBPACK FOOTER //
// ./src/plugins/screening_status.js